import React, { Component } from "react";
import "./Login.css";
import CircularProgress from "@material-ui/core/CircularProgress";

import {
    isAuthenticatedSelector,
    tokenSelector,
} from "../../redux/selectors/auth";
import {
    authLogin,
} from "../../redux/actions/auth";
import withShipment from "../../withShipment";
import ErrorFeedbackBar from "../../components/global/ErrorFeedbackBar";
import Icon from "../../hive/ui/Icon";

const beeLogo = `${process.env.PUBLIC_URL}/logo.png`;

const FEATURES = [
    { icon: "Boxes", title: "All-in-One Marketplace", text: "Every tool your business needs, in one hive." },
    { icon: "ShieldCheck", title: "Trusted & Secure", text: "One login, one account, shared permissions." },
    { icon: "Rocket", title: "Built to Grow", text: "Install only the apps you need, add more later." },
];

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: "",
            password: "",
            showPassword: false,
            error: false,
            loading: false,
        };
    }

    handle = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value, error: false });
    };

    togglePassword = () => {
        this.setState((s) => ({ showPassword: !s.showPassword }));
    };

    handleLogin = (event) => {
        event.preventDefault();
        if (!this.state.username.trim() || !this.state.password) {
            this.setState({ error: true });
            return;
        }
        this.setState({ loading: true, error: false });
        this.props.authLogin(this.state.username, this.state.password, this.props.history);

        setTimeout(() => {
            if (!this.props.isAuthenticated) {
                this.setState({ error: true, loading: false });
            }
        }, 3000);
    };

    render() {
        const { username, password, showPassword, error, loading } = this.state;
        const canSubmit = username.trim().length > 0 && password.length > 0 && !loading;
        const year = new Date().getFullYear();
        return (
            <div className="hive-root hive-login">
                <ErrorFeedbackBar />

                {/* Brand panel */}
                <aside className="hive-login-brand hive-honeycomb-bg">
                    <div className="hive-login-brand-inner">
                        <div className="hive-login-brand-lockup">
                            <div className="hive-login-logo">
                                <img src={beeLogo} alt="" />
                            </div>
                            <h1 className="hive-login-brand-title">
                                BeeNexa <span className="hive-gold-text">Hive</span>
                            </h1>
                        </div>
                        <p className="hive-login-brand-tag">
                            All the tools your business needs.
                            <br />
                            <span className="hive-gold-text">One powerful hive.</span>
                        </p>

                        <ul className="hive-login-features">
                            {FEATURES.map((f) => (
                                <li key={f.title} className="hive-login-feature">
                                    <span className="hive-login-feature-ic">
                                        <Icon name={f.icon} size={20} color="#f2c94c" />
                                    </span>
                                    <div>
                                        <div className="hive-login-feature-title">{f.title}</div>
                                        <div className="hive-login-feature-text">{f.text}</div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="hive-login-brand-foot">© {year} BeeNexa Hive</div>
                </aside>

                {/* Form panel */}
                <main className="hive-login-form-panel">
                    <form className="hive-login-card" onSubmit={this.handleLogin} noValidate>
                        <div className="hive-login-card-brand">
                            <span className="hive-login-card-tile">
                                <img src={beeLogo} alt="" className="hive-login-card-logo" />
                            </span>
                            <span className="hive-login-card-name">
                                BeeNexa <span className="hive-gold-text">Hive</span>
                            </span>
                        </div>

                        <h2 className="hive-login-heading">Welcome back</h2>
                        <p className="hive-login-subheading">Sign in to your hive to continue.</p>

                        <label className="hive-login-field">
                            <span className="hive-login-label">Email</span>
                            <div className="hive-login-input-wrap">
                                <span className="hive-login-input-icon"><Icon name="Mail" size={18} /></span>
                                <input
                                    name="username"
                                    type="email"
                                    autoComplete="username"
                                    value={username}
                                    onChange={this.handle}
                                    placeholder="you@example.com"
                                    className="hive-login-input"
                                    disabled={loading}
                                />
                            </div>
                        </label>

                        <label className="hive-login-field">
                            <span className="hive-login-label">Password</span>
                            <div className="hive-login-input-wrap">
                                <span className="hive-login-input-icon"><Icon name="Lock" size={18} /></span>
                                <input
                                    name="password"
                                    type={showPassword ? "text" : "password"}
                                    autoComplete="current-password"
                                    value={password}
                                    onChange={this.handle}
                                    placeholder="Enter your password"
                                    className="hive-login-input hive-login-input-password"
                                    disabled={loading}
                                />
                                <button
                                    type="button"
                                    className="hive-login-eye"
                                    onClick={this.togglePassword}
                                    aria-label={showPassword ? "Hide password" : "Show password"}
                                    tabIndex={-1}
                                >
                                    <Icon name={showPassword ? "EyeOff" : "Eye"} size={18} />
                                </button>
                            </div>
                        </label>

                        {error && (
                            <div className="hive-login-error" role="alert">
                                <Icon name="AlertCircle" size={18} />
                                <span>Email and password don't match. Please try again.</span>
                            </div>
                        )}

                        <button
                            type="submit"
                            className="hive-login-submit hive-tap"
                            disabled={!canSubmit}
                            onClick={this.handleLogin}
                        >
                            {loading ? (
                                <span className="hive-login-submit-loading">
                                    <CircularProgress size={20} thickness={4} style={{ color: "#2a1e00" }} />
                                    <span>Signing in…</span>
                                </span>
                            ) : (
                                <>Sign in</>
                            )}
                        </button>

                        {/* The desktop copyright lives in the brand panel, which
                            is hidden on mobile — this one only shows there. */}
                        <div className="hive-login-card-foot">© {year} BeeNexa Hive</div>
                    </form>
                </main>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    isAuthenticated: isAuthenticatedSelector(state),
    token: tokenSelector(state),
});

const actionCreators = {
    authLogin,
};

export default withShipment({
    mapStateToProps,
    actionCreators,
}, Login);
